import { render, staticRenderFns } from "./UserAvatarDisplay.vue?vue&type=template&id=53cae2c4&scoped=true"
import script from "./UserAvatarDisplay.vue?vue&type=script&lang=js"
export * from "./UserAvatarDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cae2c4",
  null
  
)

export default component.exports